import { render, staticRenderFns } from "./is-gift.vue?vue&type=template&id=24db292e&scoped=true&"
import script from "./is-gift.vue?vue&type=script&lang=js&"
export * from "./is-gift.vue?vue&type=script&lang=js&"
import style0 from "./is-gift.vue?vue&type=style&index=0&id=24db292e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db292e",
  null
  
)

export default component.exports